import { render, staticRenderFns } from "./EquipmentDetail.vue?vue&type=template&id=31625edb&"
import script from "./EquipmentDetail.vue?vue&type=script&lang=js&"
export * from "./EquipmentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports